<template>
  <div id="app">
    <!-- <router-view /> -->
    <!-- main 内容 -->
    <transition :name="mainName">
      <keep-alive v-if="$route.meta.keepAlive">
        <!-- 这里是会被缓存的视图组件 -->
        <router-view id="view" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <!-- 这里是不被缓存的视图组件 -->
      <router-view v-if="!$route.meta.keepAlive && isRouterAlive" id="view" />
    </transition>

    <!-- 底部菜单：由路由 meta.tabbar 控制显隐 -->
    <app-tab-bar v-if="isShowNav" />
  </div>
</template>
<script>
import AppTabBar from "./components/AppTabBar.vue";

/**
 * 根组件。
 *
 * 底部菜单的显隐只认路由 meta.tabbar：
 *   meta.tabbar === true → 挂载底部菜单（首页 / 学习 / 作业 / 我的）
 *
 * 原来靠 navTabs 数组（["Home","Category","Cart","Me"]）判断，但工程里没有任何
 * 路由使用这些 name，isShowNav 也一直停在 false —— 底部菜单实际从未出现过。
 * 那段失效逻辑已移除，改为按 meta.tabbar 判断。
 */
export default {
  components: {
    "app-tab-bar": AppTabBar
  },
  data() {
    return {
      mainName: "", // 内容区域过渡动画名
      isRouterAlive: true // 用于刷新页面用
    };
  },
  computed: {
    isShowNav() {
      const meta = (this.$route && this.$route.meta) || {};
      return meta.tabbar === true;
    }
  }
};
</script>
<style lang="less" scoped>
.nav-slide-enter,
.nav-slide-leave-to {
  transform: translate3d(-100%, 0, 0);
}
.nav-slide-enter-active,
.nav-slide-leave-active {
  transition: all 5.5s;
}
// 底部导航之间相互切换 内容区域动画
.fade-enter {
  opacity: 0;
}
.fade-leave {
  opacity: 1;
}
.fade-enter-active {
  transition: opacity 0.5s;
}
.fade-leave-active {
  opacity: 0;
  transition: opacity 0s;
} //底部导航栏消失时一般为立马消失
// 前进：右边页面进入的同时，同时左边页面在消失
.slide-left-enter {
  //开始过渡的开始状态为沿X轴向右平移100%，开始过渡结束时向左平移到原位
  transform: translate3d(100%, 0, 0);
}
.slide-left-leave-active {
  transform: translate3d(-100%, 0, 0);
}
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.5s;
  position: absolute; // 解决：页面切换时空白闪屏的问题
}
// 后退：左边页面进入的同时，同时右边页面在消失
.slide-right-enter {
  transform: translate3d(-100%, 0, 0);
}
.slide-right-leave-active {
  transform: translate3d(100%, 0, 0);
}

.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.5s;
  position: absolute; // 解决：页面切换时空白闪屏的问题
}
</style>
